module.exports = __webpack_public_path__ + "static/media/art_1049.50877565.jpg";